import React from 'react';
import {useSelector} from 'react-redux';
import * as S from './AccountCreated.styles';
import * as C from '../../Common.styles';
import IconSelector from '@ibibo/icon-selector';
import {useHistory, useLocation} from 'react-router-dom';
import {LOGIN_URL_NEW} from '../../../../../constants';
import {userCountrySelector} from '../../../../../store/selectors';
import {getCrid} from '../../../../../../../myaccount/src/utils/redirectWithCrId';
const AccountCreated = () => {
  const history = useHistory();
  const userCountry = useSelector(userCountrySelector);
  const openLogin = () => {
    history.push(`${LOGIN_URL_NEW}?crId=${getCrid()}`);
  };
  return (
    <S.AccountCreatedMainWrap>
      <S.AccountCreatedCommonWrap>
        <IconSelector iconKey="accountCreated" />
      </S.AccountCreatedCommonWrap>
      <S.AccountCreatedCommonWrap>
        <S.AccCreatedHeadText>Hurray! Account created</S.AccCreatedHeadText>
        <S.AccCreatedSubHeadText>
          Your myPartner Account Is Successfully Created!
        </S.AccCreatedSubHeadText>
      </S.AccountCreatedCommonWrap>
      {/* <S.AccountCreatedCommonWrap>
                <S.AccCreatedInfoHeadText>We have sent a verification link  to <strong>anandml@outlook.com</strong></S.AccCreatedInfoHeadText>
                <S.AccCreatedInfoSubText>Open that verification link to verify your email id & continue to your account.</S.AccCreatedInfoSubText>
            </S.AccountCreatedCommonWrap> */}
      <S.AccountCreatedCommonWrap>
        {userCountry ? (
          <S.AccCreatedInfoText>
            Login to your account using your E-mail id to verify your mobile number and start
            booking on myPartner. <strong>50 AED worth of promo cash</strong> has been credited to
            your Wallet as a welcome bonus!
          </S.AccCreatedInfoText>
        ) : (
          <S.AccCreatedInfoText>
            Use promocodes <strong>MYFIRSTFLIGHT</strong> & <strong>MYFIRSTHOTEL</strong> and enjoy
            additional instant discount on your first flight & hotel bookings
          </S.AccCreatedInfoText>
        )}
      </S.AccountCreatedCommonWrap>
      <S.AccountCreatedBtnWrap>
        <C.ContinueButton onClick={openLogin}>Continue to Login</C.ContinueButton>
      </S.AccountCreatedBtnWrap>
    </S.AccountCreatedMainWrap>
  );
};

export default AccountCreated;
